module.exports = __webpack_public_path__ + "img/ai-reader-book.9d244df3.png";